import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { username } from "./username";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      first_name: string;
      last_name: string;
      other_names: string;
      phone_number: string;
      email: string;
      subject_ids: Array<number>;
      utme_number: string;
    }>;
  }>("/students", { params });
};

const post = function (data: {
  first_name: string;
  last_name: string;
  other_names: string;
  phone_number: string;
  email: string;
  subject_ids: Array<number>;
  utme_number: string;
}) {
  return api.post("/students", data);
};

export const students = {
  get,
  post,
  username,
};
